import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CarouselComponent, OwlOptions } from 'ngx-owl-carousel-o';
import { HeaderComponent } from 'src/app/public-website/public-shared/header/header.component';
import { sliderImg } from 'src/app/shared/components/image-slider/image-slider.component';
import { AuthService } from '../../../../shared/services/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent implements OnInit {
  targetCount = 5000; // The target number for the counter
  currentCount = 0; // Start count at 0
  duration = 2000; // Animation duration in ms
  public authenticated: boolean = false;
  public mode: string = '';
  currentLanguages: string;
  imageUrl: string = '';
  options: OwlOptions;
  optionsLogoClient: OwlOptions;
  testimonialsOptions: OwlOptions;
  PaymentsOptionsArray: headerSlider[] = [
    { image: '../../../../../assets/images/payment-options/valu.webp' },
    { image: '../../../../../assets/images/payment-options/orange.webp' },
    {
      image:
        '../../../../../assets/images/payment-options/Bank installment.webp',
    },
    { image: '../../../../../assets/images/payment-options/etisalat cash.webp' },
    { image: '../../../../../assets/images/payment-options/fawry.webp' },
    { image: '../../../../../assets/images/payment-options/qasatly.webp' },
    { image: '../../../../../assets/images/payment-options/meeza.webp' },
    { image: '../../../../../assets/images/payment-options/visa.webp' },
    { image: '../../../../../assets/images/payment-options/voda.webp' },
    { image: '../../../../../assets/images/payment-options/aman.webp' },
    { image: '../../../../../assets/images/payment-options/contact.webp' },
    { image: '../../../../../assets/images/payment-options/souhoola.webp' },
  ];

  clientsLogoArray = [
    {
      image: '../../../../../assets/images/clients-logo/1.webp',
      name: 'Doctor smile clinic',
    },
    {
      image: '../../../../../assets/images/clients-logo/2.webp',
      name: 'Divine clinic',
    },
    {
      image: '../../../../../assets/images/clients-logo/3.webp',
      name: 'Dentitna central',
    },
    {
      image: '../../../../../assets/images/clients-logo/4.webp',
      name: 'Dental clinic',
    },
    {
      image: '../../../../../assets/images/clients-logo/5.webp',
      name: 'Dawa hospital',
    },
    {
      image: '../../../../../assets/images/clients-logo/6.webp',
      name: 'Career 180',
    },
    {
      image: '../../../../../assets/images/clients-logo/7.webp',
      name: 'Broklyn business school',
    },
    {
      image: '../../../../../assets/images/clients-logo/8.webp',
      name: 'Barokkty',
    },
    {
      image: '../../../../../assets/images/clients-logo/9.webp',
      name: '7D Clinics',
    },
    {
      image: '../../../../../assets/images/clients-logo/10.webp',
      name: 'Ziad akram',
    },
    {
      image: '../../../../../assets/images/clients-logo/11.webp',
      name: 'Zac electronics',
    },
    {
      image: '../../../../../assets/images/clients-logo/12.webp',
      name: 'Tree of life',
    },
    {
      image: '../../../../../assets/images/clients-logo/13.webp',
      name: 'The somatic therapist',
    },
    {
      image: '../../../../../assets/images/clients-logo/14.webp',
      name: 'The english coach',
    },
    {
      image: '../../../../../assets/images/clients-logo/15.webp',
      name: 'Sports performance',
    },
    {
      image: '../../../../../assets/images/clients-logo/16.webp',
      name: 'Skins clinic',
    },
    {
      image: '../../../../../assets/images/clients-logo/17.webp',
      name: 'Sarhan Obesity Clinic',
    },
    {
      image: '../../../../../assets/images/clients-logo/18.webp',
      name: 'Room art space',
    },
    {
      image: '../../../../../assets/images/clients-logo/19.webp',
      name: 'Osana family wellness',
    },
    {
      image: '../../../../../assets/images/clients-logo/20.webp',
      name: 'My happy clinics',
    },
    {
      image: '../../../../../assets/images/clients-logo/21.webp',
      name: 'Mind builders',
    },
    {
      image: '../../../../../assets/images/clients-logo/22.webp',
      name: 'Mental health hub',
    },
    {
      image: '../../../../../assets/images/clients-logo/23.webp',
      name: 'Maria store',
    },
    {
      image: '../../../../../assets/images/clients-logo/24.webp',
      name: 'Manage the now',
    },
    {
      image: '../../../../../assets/images/clients-logo/25.webp',
      name: 'leaders',
    },
    {
      image: '../../../../../assets/images/clients-logo/26.webp',
      name: 'Footloose',
    },
    {
      image: '../../../../../assets/images/clients-logo/27.webp',
      name: 'Entrepenelle',
    },
    {
      image: '../../../../../assets/images/clients-logo/28.webp',
      name: 'Engineerex',
    },
    {
      image: '../../../../../assets/images/clients-logo/29.webp',
      name: 'Dr Tarek Abdelhares',
    },
    {
      image: '../../../../../assets/images/clients-logo/30.webp',
      name: 'Dr. Ramy Alanany',
    },
    {
      image: '../../../../../assets/images/clients-logo/31.webp',
      name: 'Sam samouy',
    },
    {
      image: '../../../../../assets/images/clients-logo/32.webp',
      name: 'Russian culture center',
    },
    {
      image: '../../../../../assets/images/clients-logo/33.webp',
      name: 'Kimit academy',
    },
    {
      image: '../../../../../assets/images/clients-logo/34.webp',
      name: 'Dott jeans',
    },
    {
      image: '../../../../../assets/images/clients-logo/35.webp',
      name: 'Transform ',
    },
    {
      image: '../../../../../assets/images/clients-logo/36.webp',
      name: 'Honey moonerz travel',
    },
    {
      image: '../../../../../assets/images/clients-logo/37.webp',
      name: 'Out to see',
    },
    {
      image: '../../../../../assets/images/clients-logo/38.webp',
      name: 'Stanly egypt',
    },
  ];
  feedbackArray = [
    {
      busniessName: 'I am a live store',
      feedback:
        'سعيد جداااا ب التعامل مع Easykash من اول يوم بدأت معاهم فيه، حلول الدفع المتكامله اللي بيقدموها بتسهل كتير علي العملاء عملية الدفع. وأكتر ميزه عندهم هي ال customer service اللي بتحل اي مشكله في اقل وقت حرفيا عن اي مقدم خدمه تاني.',
      title: 'I am a live owner',
      type: 'male',
    },
    {
      busniessName: 'Russian computer center',
      feedback:
        'ايزي كاش احد شركاء النجاح حيث انها اسهمت في تطوير خدمات الدفع لعملائنا وقامت بتوفير الوقت والمجهود بتقديم حلول ذكيه ومتطوره ومتنوعه دعم رائع وحل للمشاكل علي مدار اليوم بقياده المتميزه مونيكا التزام في مواعيد الدفع والتحويلات موقع سهل التعامل للعملاء',
      title: 'رئيس مجلس الاداره والعضو المنتدب',
      type: 'male',
    },
    {
      busniessName: 'Get nourished by nehal',
      feedback:
        'Easykash is an excellent service! Very smooth transactions, responsive customer service. What I love most about Easykash is that they are always improving and adding new services like instant withdrawal and sms marketing. Highly recommended customer service',
      title: 'Business owner',
      type: 'female',
    },
    {
      busniessName: 'Ziad akram',
      feedback:
        'علي مدار السنين الي فاتت اتعاملت مع اكتر من شركة تحصيل اموال ووسائل دفع لشغلي كنت بواجهه مشاكل كتير مختلفة وصعوبات ولقيت حلول لكل المشاكل ده مع easykash ودي تاني سنه تعاون بنا ومكملين ان شاء الله.',
      title: 'Business owner ',
      type: 'male',
    },
    {
      busniessName: 'Abdelrahman ElGendy',
      feedback:
        'We had a great experience with Easykash for almost two years. The range of payment services, flexibility and professionalism made them stand out to our company, and our first impressions were confirmed as the months flew by. <br> What I found to set them apart was the extremely responsive customer service that attentively follows up on any arising problem and solves it as soon as possible—my account manager has not failed to deliver the best service to date.',
      title: 'Founder and Manager of The English Coach',
      type: 'male',
    },
  ];

  howItWorks = [
    { icon: '../../../../../assets/images/icons/Create.webp', altText: 'Create', title: 'Home.How.Create', description: 'Home.How.CreateP' },
    { icon: '../../../../../assets/images/icons/Share.webp', altText: 'Share', title: 'Home.How.Share', description: 'Home.How.ShareP' },
    { icon: '../../../../../assets/images/icons/Earn.webp', altText: 'Earn', title: 'Home.How.Earn', description: 'Home.How.EarnP' }
  ];

  servicesList = [
    {
      icon: 'fas fa-file-invoice-dollar',
      title: 'Home.Services.Invoice',
      description: 'Home.Services.InvoiceDesc',
      link: '/services/invoice'
    },
    {
      icon: 'fas fa-comment-dollar',
      title: 'Home.Services.Subscription',
      description: 'Home.Services.SubscriptionDesc',
      link: '/services/subscription'
    },
    {
      icon: 'fas fa-receipt',
      title: 'Home.Services.CustomPayment',
      description: 'Home.Services.CustomPaymentDesc',
      link: '/services/customPayment'
    },
    {
      icon: 'fas fa-store',
      title: 'Home.Services.Product',
      description: 'Home.Services.ProductDesc',
      link: '/services/product'
    },
    {
      icon: 'fas fa-wallet',
      title: 'Home.Services.QuickCash',
      description: 'Home.Services.QuickCashDesc',
      link: '/services/quickCash'
    },
    {
      icon: 'fa fa-light fa-credit-card',
      title: 'Home.Services.QuickPayment',
      description: 'Home.Services.QuickPaymentDesc',
      link: '/services/quickPayment'
    },
    {
      icon: 'fa fa-light fa-calendar-check',
      title: 'Home.Services.EReservation',
      description: 'Home.Services.EReservationDesc',
      link: '/services/e-Reservation'
    },
    {
      icon: 'fas fa-calendar-plus',
      title: 'Home.Services.BookingEvents',
      description: 'Home.Services.BookingEventsDesc',
      link: '/services/booking&Events'
    },
    {
      icon: 'fa fa-building-columns',
      title: 'Home.Services.InstallmentOptions',
      description: 'Home.Services.InstallmentOptionsDesc',
      link: '/services/installmentOptions'
    }
  ];

  feesArray = [
    { image: 'deveploment.webp', title: 'Home.Development', description: 'Home.DevelopmentDescription', alt: 'Development' },
    { image: 'regestration.webp', title: 'Home.Registration', description: 'Home.RegistrationDescription', alt: 'Registration' },
    { image: 'minimal-fees.webp', title: 'Home.Fees', description: 'Home.FeesDescription', alt: 'Minimal Fees' },
    { image: 'Secure payments.webp', title: 'Home.SecurePayments', description: 'Home.SecurePaymentsDescription', alt: 'Secure Payments' },
    { image: 'strong-solution.webp', title: 'Home.Solution', description: 'Home.SolutionDescription', alt: 'Strong Solution' },
    { image: 'payment-options.webp', title: 'Home.PaymentOptions', description: 'Home.PaymentOptionsDescription', alt: 'Payment Options' }
  ];

   counterData = [
    { icon: 'transc', altText: 'Total Transactions', target: 200, default: 11000, suffix: 'M+', label: `Home.Transactions` },
    { icon: 'merchant', altText: 'Total Merchants', target: 5000, default: 1, suffix: '+', label: `Home.Merchants` },
    { icon: 'buyers', altText: 'Total Buyers', target: 5000, default: 1, suffix: '', label: `Home.Buyers` },
    { icon: 'products', altText: 'Total Products', target: 20000, default: 1, suffix: '', label: `Home.Product` }
  ];

  plans = [
    {
      title: 'Home.Plans.Startup',
      price: '3.5%',
      description: ['Home.Plans.StartupDesc1', 'Home.Plans.StartupDesc2'],
      route: 'https://bit.ly/4lhxFlE',
      special: false // No special background
    },
    {
      title: 'Home.Plans.SmallBusiness',
      price: '2.5%',
      description: ['Home.Plans.SmallBusinessDesc1', 'Home.Plans.SmallBusinessDesc2'],
      route: 'https://bit.ly/4lhxFlE',
      special: true // This plan has a special background color
    },
    {
      title: 'Home.Plans.Enterprise',
      price: '2%',
      description: ['Home.Plans.EnterpriseDesc1', 'Home.Plans.EnterpriseDesc2'],
      route: 'https://bit.ly/4lhxFlE',
      special: false // No special background
    }
  ];


  @ViewChild('owlCar') owlCar: CarouselComponent;
  @ViewChild(HeaderComponent) header: HeaderComponent;
  constructor(
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService
  ) {
    this.options = {
      loop: true,
      mouseDrag: true,
      touchDrag: true,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplaySpeed: 500,
      items: 1,
      dots: true,
      autoWidth: true,
      nav: false,
      responsiveRefreshRate: 500,
      responsive: {
        0: {
          items: 2,
        },
        600: {
          items: 3,
        },
        1000: {
          items: 5,
        },
      },
    };
    this.testimonialsOptions = {
      loop: true,
      mouseDrag: true,
      touchDrag: true,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplaySpeed: 500,
      items: 1,
      dots: true,
      autoWidth: true,
      nav: false,
    };
    this.optionsLogoClient = {
      loop: true,
      mouseDrag: true,
      touchDrag: true,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplaySpeed: 500,
      items: 1,
      dots: false,
      autoWidth: true,
      nav: true,
      navText: [
        '<i class="fa fa-angle-left" aria-hidden="true"></i>',
        '<i class="fa fa-angle-right" aria-hidden="true"></i>',
      ],
      responsiveRefreshRate: 500,
      responsive: {
        0: {
          items: 2,
        },
        600: {
          items: 3,
        },
        1000: {
          items: 5,
        },
      },
    };
  }

  async ngOnInit(): Promise<void> {
    this.currentLanguages = localStorage.getItem('language') || 'en';
     this.imageUrl = this.currentLanguages === 'ar'
  ? '/assets/images/mockup/home-page-Ar-laptop.webp'
  : '/assets/images/mockup/home-page-en-laptop.webp';
    this.translate.onLangChange.subscribe((res) => {
      let lang = res.lang;
      this.currentLanguages = lang;
      this.options =
        lang === 'en' ? this.options : { ...this.options, rtl: true };
      this.optionsLogoClient =
        lang === 'en'
          ? this.optionsLogoClient
          : { ...this.optionsLogoClient, rtl: true };
      this.testimonialsOptions =
        lang === 'en'
          ? this.testimonialsOptions
          : { ...this.testimonialsOptions, rtl: true };
    });
    this.authenticated = this.authService.isAuthenticated();
    if (this.authenticated) {
      const url = await this.authService.dashboardUrl();
      if (url) this.router.navigate([url]);
    }
  }

  @ViewChild('counterSection') counterSection!: ElementRef;
  @ViewChild('counterElement', { static: false }) counterElement!: ElementRef;

  ngAfterViewInit() {
    this.startCounterAnimation();
    this.animateCounter();
  }

  startCounterAnimation() {
    const counters = this.counterSection.nativeElement.querySelectorAll('.counter-value');

    counters.forEach((counter: any) => {
      const target = +counter.getAttribute('data-target');
      let count = 0;
      const increment = Math.ceil(target / 100);

      const updateCounter = () => {
        count += increment;
        if (count < target) {
          counter.innerText = count;
          setTimeout(updateCounter, 20);
        } else {
          counter.innerText = target;
        }
      };
      updateCounter();
    });
  }

  animateCounter() {
    const startTime = performance.now();

    const step = (currentTime: number) => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / this.duration, 1);
      this.currentCount = Math.floor(progress * this.targetCount);

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  }

  trackByFn(index: number, slide: any): number {
    return slide.id; // Use a unique identifier for tracking
  }
}
export interface headerSlider extends sliderImg {
  desc?: string;
  tilte?: string;
  styleId?: string;
}
